import { AnalyticsInstitutionDashboard, CourseAnalyticsDashboard } from '../components/analytics-dashboard';
import CourseAnalytics from '../components/course-analytics';

/* @ngInject */
export default function AnalyticsDashboardCtrl(
  $scope,
  $uibModal,
  $controller,
  CourseModel,
  StateManager,
  AlertMessages,
  TimelineModel,
  ConfettiAnimation,
  DashboardResources,
  ConfirmationOverlays,
) {
  $scope.$uibModal = $uibModal;
  $scope.CourseModel = CourseModel;
  $scope.$controller = $controller;
  $scope.StateManager = StateManager;
  $scope.AlertMessages = AlertMessages;
  $scope.TimelineModel = TimelineModel;
  $scope.ConfettiAnimation = ConfettiAnimation;
  $scope.DashboardResources = DashboardResources;
  $scope.AnalyticsInstitutionDashboard = AnalyticsInstitutionDashboard;
  $scope.CourseAnalytics = CourseAnalytics;
  $scope.ConfirmationOverlays = ConfirmationOverlays;
}
